import { Dialog, DialogOverlay } from "@/components/ui/dialog";
import { useEffect, useState, type FC } from "react";
import StepOne from "./StepOne";
import StepTwo from "./StepTwo";
import { useNavigate } from "react-router";
import StepThree from "./StepThree";
import {
  resetSubmitOnboardingState,
  submitOnboarding,
  submitOnboardingState,
  type SubmitOnboardingParams,
} from "@/store/submitOnboardingState";
import { toast } from "sonner";
import { triggerEvent } from "@/lib/utils";
import mixpanel from "mixpanel-browser";

const Onboarding: FC = () => {
  const navigate = useNavigate();

  const { data, isLoading, error } = submitOnboardingState();

  const [step, setStep] = useState(1);
  const [valueToSubmit, setValueToSubmit] = useState<SubmitOnboardingParams>({
    job: "",
    numberOfLocations: "",
    businessObjectives: [],
  });

  const onChangeValue = (name: string, value: string | string[]) => {
    const newValue: SubmitOnboardingParams = {
      ...valueToSubmit,
      [name]: value,
    };

    if (["job", "numberOfLocations"].includes(name)) {
      setValueToSubmit(newValue);
      setStep((prevState) => prevState + 1);
    }

    if (name === "businessObjectives") {
      setValueToSubmit(newValue);
      submitOnboarding(newValue);
    }
  };

  useEffect(() => {
    triggerEvent("Onboarding Started");
  }, []);

  useEffect(() => {
    if (error) {
      toast.error("Erreur de l'envoie du formulaire", {
        duration: 2000,
      });
      resetSubmitOnboardingState();
      navigate("/");
    }

    if (data) {
      triggerEvent("role", {
        role: valueToSubmit.job,
      });

      triggerEvent("num_stores", {
        num_stores: valueToSubmit.numberOfLocations,
      });

      triggerEvent("business_goals", {
        business_goals: valueToSubmit.businessObjectives,
      });

      triggerEvent("Onboarding Completed");

      mixpanel.people.set({
        role: valueToSubmit.job,
        business_goal: valueToSubmit.numberOfLocations,
        num_stores: valueToSubmit.businessObjectives,
      });

      resetSubmitOnboardingState();

      if (valueToSubmit.numberOfLocations === "no_store") navigate("/");

      if (valueToSubmit.numberOfLocations !== "no_store")
        navigate("/onboarding-add-restaurants");
    }
  }, [data, error]);

  return (
    <Dialog open>
      <DialogOverlay
        style={{
          WebkitMaskImage:
            "linear-gradient(to bottom, rgba(255, 255, 255, 0.6) 35%, rgba(255, 255, 255, 1) 65%)",
          maskImage:
            "linear-gradient(to bottom, rgba(255, 255, 255, 0.6)%, rgba(255, 255, 255, 1))",
        }}
        className="backdrop-blur-[10px]"
      />
      {step === 1 && <StepOne onChangeValue={onChangeValue} />}
      {step === 2 && <StepTwo onChangeValue={onChangeValue} />}
      {step === 3 && (
        <StepThree onChangeValue={onChangeValue} isLoading={isLoading} />
      )}
    </Dialog>
  );
};

export default Onboarding;
